import React, { useState, useEffect } from 'react';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import Switch from "react-switch";

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Paper, Table, TableBody, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core';

// import Loader from 'react-loader';

import { ProgressAlert } from '../controls';
import { StyledTableCell, StyledTableCellHeader } from '../datagrid/StyledTableCell';
import StyledTableRow from '../datagrid/StyledTableRow';
import {MatUIClasses, TablePaginationStyle} from '../datagrid/styles';

import { QueueTrackerService } from '../../services';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const memberStyles = {
  span: {
    fontSize: 16,
    marginLeft: 5,
    verticalAlign: 'middle'
  },
  table: {
    fontSize: 14,
    width: '100%',
    background: 'transparent',
    tr: {
      border: 'none'
    },
    tdFilterControl: {
      padding: 0
    },
    tdFilterButton: {
      padding: 0,
      maxWidth: 20
    }
  }
}

// // Add props that will be received from another component
// interface DisplayProps {
//   userMe: any;
// }

interface iQueueProps {
  id: string;
  name: string;
  joined: boolean;
  joinedChangedInApp: boolean;
}

interface iQueueTrackerProps {
  clientOrg: string;
}

/********* Necesary to handle notifications. State not recognized.  **********/
var globalUserQueues: Array<any> = [];
var globalUserMe: any = {};
let platformClient: any;
/*****************************************************************************/

const QueueTracker: React.FC<iQueueTrackerProps> = (props) => {
  const classes = useStyles();
  const matUIClasses = MatUIClasses();
  let processedQueuesCount = 0;
  
  const [clientOrg, setClientOrg] = useState(props.clientOrg);       // Genesys Org for signed in user. Also may be set in Multitenant.
  const [progressMessage, setProgressMessage] = useState('Loading user queues.');         // Progress message displayed in the ProgressAlert. Set to '' when loading finishes.
  const [loading, setLoading] = useState(true);                      // Flag used for the loading component
  const [updatingQueue, setUpdatingQueue] = React.useState(false);   // Flag used to show backdrop with updating queue
  const [filterStr, setFilterStr] = useState("");                     // Used to filter both tables.

  const [userMe, setUserMe] = useState<any>({});                      // Current Logged in User
  const [userQueues, setUserQueues] = useState<iQueueProps & any>();  // Queues assigned to User.
  const [currentPageQB, setCurrentPageQB] = useState(0);              // Current page for the Users Table pagination option
  const [rowsPerPageQB, setRowsPerPageQB] = useState(15);             // Number of records shown for the Users Table pagination option
  const [notificationTopics, setNotificationTopics] = useState<Array<string>>([]);   // Contains all of the notification topics that the app is registered to
  
  /**
   * Shows a message in a toast error element.
   * @param errorMessage Message to display.
   */
  const _MsgError = (errorMessage: string) => {
    NotificationManager.error(errorMessage, 'Error', 5000);
  }
  
  /**
   * Shows a message in a toast warning element.
   * @param message Message to display.
   * @param autoClose True if notification needs to autoclose, false elsewhere.
   * @param timeOut Milliseconds that the notification will remain open until autoclose.
   */
  const _MsgWarning = (message: string, autoClose: boolean = true, timeOut?: number) => {
    timeOut = autoClose ? (timeOut || 5000) : 120000;
    
    NotificationManager.warning(message, '', timeOut);
  }
  
  /**
   * Shows a message in a toast success element.
   * @param message Message to display.
   */
  const _MsgSuccess = (message: string) => {
    NotificationManager.success(message, '', 5000);
  }

  /**
   * Splits a notification topic by seperator (.).
   * @param notificationTopic Topic to split.
   * @returns An array of topic sections.
   */
  const splitNotificationTopic = (notificationTopic: string) => {
    return notificationTopic.split('.');
  }

  /**
   * Handles queue types notifications.
   * @param notification Notification sent by Genesys.
   * @param notificationTopicArray An array of topic sections.
   */
  const handleQueueNotification = (notification: any, notificationTopicArray: Array<any>) => {

    if (notificationTopicArray[2] === 'queues' && notificationTopicArray[4] === 'users') {
      let notificationQueueData = notification.eventBody;
      let userId = notificationQueueData.user.id;
      
      if (globalUserMe.id === userId) {
        globalUserQueues = globalUserQueues.map((queue: iQueueProps) => {
          if (queue.id === notificationQueueData.queueId && queue.joined !== notificationQueueData.joined && !queue.joinedChangedInApp)
            _MsgWarning('Activating/Deactivating outside of the app will cause errors in queue logging. Notifying management.', true, 7000);
          return (queue.id === notificationQueueData.queueId ? {...queue, joined: notificationQueueData.joined, joinedChangedInApp: false} : queue);
        });
        setUserQueues(globalUserQueues);
      }
    }
  }

  /**
   * Handle incoming PureCloud notification from WebSocket.
   * @param message Notification sent by Genesys.
   */
  const handleNotification = (message: any) => {
    // if (!loadingFinished)
    //   return;
    // Parse notification string to a JSON object
    let queueTopicPrefix = 'v2.routing.queues.';
    // v2.routing.queues.605ec9c1-05a3-4eaf-af19-79ed7a776ef4.users
    // v2.users.624fdbe2-f006-453a-b0cd-bf0dd89cb1a9.presence

    const notification = JSON.parse(message.data as string);
    const notificationTopic = notification.topicName.toLowerCase();

    // console.log('notification: ', notification);
    // console.log('notificationTopic: ', notificationTopic);

    // Discard unwanted notifications
    if (notification.topicName.toLowerCase() === 'channel.metadata') {
      // Unexpected topic
      return;
    } else if (notificationTopic.startsWith(queueTopicPrefix)) {
      handleQueueNotification(notification, splitNotificationTopic(notificationTopic));
    }
  }

  /**
   * Generates a Genesys notification topic to register to based on a User or a Queue.
   * @param topics Array that will contain Notifications Topic to register to.
   * @param divisionObjects Users/Queues objects to register to.
   * @param mockups Prefix and Sufix for notification topic.
   */
  const getItemNotificationTopics = (topics: Array<any>, divisionObjects: Array<any>, mockups: Array<any>) => {
    for (var x = 0, len2 = mockups.length; x < len2; x++) {
      let prefix = mockups[x].prefix, suffix = mockups[x].suffix;
      for (var i = 0, len = divisionObjects.length; i < len; i++) {
        const item = divisionObjects[i];
        // Validate if item already has a notification service registered. If not, register to notifications
        const notificationTopic: string = prefix + item.id + suffix;
        if (notificationTopics.indexOf(notificationTopic) < 0) {
          setNotificationTopics(notificationTopics.concat(notificationTopic));
          topics.push({ id: notificationTopic } );
        }
      }
    }
  }

  /**
   * Generates an array of Genesys notification topics to register to based on a User or a Queue.
   * @returns Array of Genesys notifications topics to register to.
   */
  const getNotificationTopics = () => {
    const topics: Array<any> = [];
    getItemNotificationTopics(topics, globalUserQueues, [{prefix: 'v2.routing.queues.', suffix: '.users'}]);
    return topics;
  }

  /**
   * Register websocket to get notifications related to user presence from PureCloud.
   */
  const registerToNotifications = () => {
    setProgressMessage('Configuring notifications...');
    const client = platformClient.ApiClient.instance;
		const notificationsApi = new platformClient.NotificationsApi();

		// Set PureCloud settings
		// client.setEnvironment('mypurecloud.com');
    client.setPersistSettings(true, 'pc-queuelog');
		let webSocket = null;
    let notificationChannel;

    notificationsApi.postNotificationsChannels()
      .then((channel: any) => {
        notificationChannel = channel;

        // Set up web socket
        webSocket = new WebSocket(notificationChannel.connectUri);
        webSocket.onmessage = handleNotification;

        // Subscribe to authenticated user's presence
        const notificationTopics = getNotificationTopics();
        // console.log('Notification topics: ', notificationTopics);
        return notificationsApi.putNotificationsChannelSubscriptions(notificationChannel.id, notificationTopics);
      })
      .then((channel: any) => {
        // Last step. Set progress message to blank.
        setProgressMessage('');
        console.log('Channel subscriptions set successfully');
        // Hide progress message.
        setLoading(false);
      })
      .catch((err: Error) => console.error(err));
  }

  /**
   * Sets the currently displayed page in the Members/User table pagination element.
   * @param newPage Zero based Page index to display in pagination.
   */
  const setPageQB = (newPage: number) => {
    setCurrentPageQB(newPage);
  }

  /**
   * Event called when the page on the Memebers Table is changed.
   * @param event Null
   * @param page Zero based page index.
   */
  const handleChangePageQB = (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, page: number) => {
    setPageQB(page);
  }

  /**
   * Event called when the rows per page on the Members Table is changed.
   * @param event HTML Element value change event object.
   */
  const handleChangeRowsPerPageQB = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPageQB(+event.target.value);
    setPageQB(0);   // Sets displayed page to first page everytime display row count changes.
  }

  /**
   * 
   * @param apiInstance Genesys API instance object of type platformClient.UsersApi().
   * @param user User to search for assigned queues.
   * @param pageNumber Genesys API pagination number. Starts at 1.
   */
  const GetUserQueues = (apiInstance: any, user: any, pageNumber: number) => {
    let userId = user.id; // String | User ID
    let opts = { 
      'pageSize': 100, // Number | Page size
      pageNumber, // Number | Page number
    };

    apiInstance.getUserQueues(userId, opts)
    .then((data: any) => {
        // Succesfully obtained the queues assigned to the user
        globalUserQueues.push(...data.entities);

        if (+data.pageNumber >= +data.pageCount) {
          globalUserQueues.sort(function (a: any, b: any) {
            if (a.name < b.name) {
                return -1;
            }
            if (b.name < a.name) {
                return 1;
            }
            return 0;
          });
          globalUserQueues = globalUserQueues.map((userQueue: iQueueProps) => { 
            return { ...userQueue, joinedChangedInApp: false } 
          });

          setUserQueues(globalUserQueues);
          registerToNotifications();
        } else
          GetUserQueues(apiInstance, user, ++pageNumber)
    })
    .catch((err: any) => {
        console.log('There was a failure calling getUserQueues');
        console.error(err);
        if (err.body && err.body.code === 'too.many.requests')
          _MsgWarning('Request limit exceeded. Please refresh(F5) the page to continue.', false, 0);
        else
          _MsgError('User queues not configure correctly. Please verify the division for the user and user roles.')
    });
  }

  /**
   * Initializes the Queue component. Called from on component mount.
   */
  const initialize = () => {
    platformClient = (window as any).platformClient;
    let apiInstance = new platformClient.UsersApi();
    let opts = { 
        'expand': ["division", "organization"] // [String] | Which fields, if any, to expand.
    };
    apiInstance.getUsersMe(opts)
    .then((data: any) => {
      globalUserMe = data;

      // If Multitenant doesn't have client org configured, set org as the logged in user org.
      if (!props.clientOrg || props.clientOrg.trim().length <= 0)
        setClientOrg(data.organization.thirdPartyOrgName);
        
      setUserMe(data);
      GetUserQueues(apiInstance, data, 1);
    })
    .catch((err: any) => {
        console.log('There was a failure calling getUsersMe');
        console.error(err);
    });
  }

  /**
   * Called when activating/deactivating a queue.
   * @param apiInstance Genesys API instance object of type platformClient.UsersApi().
   * @param queue Queue object to change joined status.
   * @param allQueues Flag: true, if setting all queues, false elsewere.
   */
  const changeQueueActivateStatus = (apiInstance: any, queue: iQueueProps, allQueues: boolean) => {
    if (!allQueues)
      setUpdatingQueue(true);
    
    let queueId = queue.id; // String | Queue ID
    let queueName = queue.name; // String | Queue Name
    let memberId = userMe.id; // String | Member ID
    let queueOldJoinedValue = queue.joined;
    queue.joined = !queueOldJoinedValue;
    globalUserQueues = userQueues.map((userQueue: iQueueProps) => { return userQueue.id === queue.id ? { ...userQueue, joinedChangedInApp: true } : { ...userQueue, joinedChangedInApp: false } });
    apiInstance.patchUserQueue(queueId, memberId, queue)
    .then((data: iQueueProps) => {

      const queueTrackerData = {
        clientOrg: clientOrg,
        userEmail: userMe.username,
        queueId,
        queueName,
        joined: queue.joined
      };
      
      return QueueTrackerService.setQueueTracker(queueTrackerData);

    })
    .then((res: any) => {
      processedQueuesCount++;
      if (!allQueues) {     // Updateing a single queue
        if (queueOldJoinedValue)    // deactivating queue
          _MsgSuccess('Queue deactivated successfully.');
        else                          // activating queue
          _MsgSuccess('Queue activated successfully.');
      } else if (processedQueuesCount === userQueues.length) {    // If updating all queues. Only show notification at the end.
        if (queueOldJoinedValue)    // deactivating queue
          _MsgSuccess('Queues deactivated successfully.');
        else                          // activating queue
          _MsgSuccess('Queues activated successfully.');
      }

      // console.log(res);
      if (res.status !== 200)
        _MsgWarning(`(${queueName}) ${res.status} - ${res.data}`, true, 5000);
      
      if (!allQueues || processedQueuesCount === userQueues.length)
        setUpdatingQueue(false);
      // _MsgSuccess(`Queue ${queueCurrentJoinedValue ? 'deactivated' : 'activated' } successfully.`);
      // globalUserQueues = userQueues.map((userQueue: any) => { return userQueue.id === queue.id ? { ...userQueue, joined: !queue.joined } : userQueue });
      // setUserQueues(globalUserQueues);
    })
    .catch((err: Error) => {
      console.log('There was a failure calling patchUserQueue');
      console.error(err);
      if (!allQueues || processedQueuesCount === userQueues.length)
        setUpdatingQueue(false);
      _MsgError(err.message);
    });
  }

  /**
   * Export unexported user queues.
   */
  const sendQueueTrackersToEmail = () => {
    setUpdatingQueue(true);
    const userData = {
      clientOrg: clientOrg,
      userEmail: userMe.username
    };
    
    QueueTrackerService.shareQueueTrackers(userData)
    .then((res: any) => {
      // console.log(res);
      if (res.status === 200)
        _MsgSuccess(res.data);
      else if (res.status === 210)
        _MsgWarning(res.data);
      else if (res.status === 211)
        _MsgWarning(res.data);
      else
        _MsgError(res.data);

      setUpdatingQueue(false);
    })
    .catch((err: Error) => {
      setUpdatingQueue(false);
      console.log('There was a failure calling sendQueueTrackersToEmail');
      console.error(err);
      _MsgError(err.message);
    });
  }

  /**
   * Activates/Deactivates all queues assigned to a user.
   * @param joinedState true if activating a Queue, false elsewhere.
   */
  const changeAllQueueActivateStatus = (joinedState: boolean) => {
    setFilterStr("");
    processedQueuesCount = 0;
    let apiInstance = new platformClient.UsersApi();

    for (const queue of userQueues) {
      if (queue.joined !== joinedState) {
        setUpdatingQueue(true);
        changeQueueActivateStatus(apiInstance, queue, true);
      } else
        processedQueuesCount++;
    }
  }

  /**
   * Called once when component loads.
   */
  useEffect(() => {
    initialize();
  // eslint-disable-next-line
  }, []);

  return (
    <div>
      <NotificationContainer />
      { loading
        ? <React.Fragment>
            <ProgressAlert alertMessage={progressMessage} />
            <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </React.Fragment>
        : <React.Fragment>
            <table style={ memberStyles.table }>
              <tbody>
                <tr style={ memberStyles.table.tr }>
                  <td style={ memberStyles.table.tdFilterControl }>
                    <div className="input-field">
                      <i className="fa fa-search fa-2x prefix" style={{ color: '#ff4f1f' }}/>
                      <input id="icon_prefix" type="text"
                          value={ filterStr }
                          onChange={ e => setFilterStr(e.target.value) } />
                      <label htmlFor="icon_prefix">Search...</label>
                    </div>
                  </td>
                  <td style={ memberStyles.table.tdFilterButton }>
                    <Button color="inherit" className={ matUIClasses.focusTransparent } 
                      style={{ marginLeft: 10, paddingLeft: 0, paddingRight: 0, minWidth: 30, minHeight: 30 }}
                      onClick={ e => sendQueueTrackersToEmail() } aria-label="send queue trackers" title="Send queue trackers">
                      <i className="fa fa-paper-plane fa-2x" style={{ color: '#444a52' }} />
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>

            <Backdrop className={matUIClasses.backdrop} open={ updatingQueue }>
              <CircularProgress color="inherit" />
            </Backdrop>
            <TableContainer component={ Paper } className={ matUIClasses.paper } style={{ borderRadius: 0 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                      <StyledTableCellHeader colSpan={2} align="right">
                        <Button variant="contained" className={ matUIClasses.genesysButton } 
                        aria-label="send queue trackers" title="Send queue trackers"
                        onClick={(e) => changeAllQueueActivateStatus(true)}>
                          Activate All
                        </Button>
                        <Button variant="contained" className={ matUIClasses.genesysButton } 
                        aria-label="send queue trackers" title="Send queue trackers"
                        onClick={(e) => changeAllQueueActivateStatus(false)}>
                          Deactivate All
                        </Button>
                      </StyledTableCellHeader>
                  </TableRow>
                  <TableRow>
                      <StyledTableCellHeader>Queue Name</StyledTableCellHeader>
                      <StyledTableCellHeader align="right">Active</StyledTableCellHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userQueues.filter((e: any) => e['name'] && e['name'].toLowerCase().includes(filterStr.toLowerCase()))
                    .slice(currentPageQB * rowsPerPageQB, currentPageQB * rowsPerPageQB + rowsPerPageQB)
                    .map((row: any, index: number) => (
                    <StyledTableRow key={ row.id }>
                      <StyledTableCell><span style={memberStyles.span}>{ row.name }</span></StyledTableCell>
                      <StyledTableCell align="right">
                        <Switch className="right"
                            onChange={(e) => changeQueueActivateStatus(new platformClient.UsersApi(), row, false)}
                            checked={ row.joined } 
                            uncheckedIcon={false}
                            checkedIcon={false}
                            id="normal-switch" />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination style={ TablePaginationStyle }
              rowsPerPageOptions={[10, 15, 25]}
              component="div"
              count={userQueues.length}
              rowsPerPage={rowsPerPageQB}
              page={currentPageQB}
              backIconButtonProps={{
                'aria-label': 'Previous Page',
                'className':  matUIClasses.focusTransparent
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page',
                'className':  matUIClasses.focusTransparent
              }}
              onPageChange={handleChangePageQB}
              onRowsPerPageChange={handleChangeRowsPerPageQB}
            />
          </React.Fragment>
      }
    </div>
  )
}

export default QueueTracker;